import React from 'react';
import { formatSocClassification } from 'src/components/Profiles/components/ProfileDetails/socTypes';

const SiteBySiteOfCareTypeItem = ({ siteOfCareType }) => {
  // The aggregation returns `site_of_care_type` (no subtype), not an entity row.
  const label =
    formatSocClassification({ soc_type: siteOfCareType?.site_of_care_type }) ||
    '—';

  return (
    <div
      data-testid="site-of-care-type-item"
      className="w-full h-14 px-2 py-1.5 bg-white border-b border-neutral-200 flex items-center justify-between"
    >
      <div
        data-testid="site-of-care-type-name"
        className="text-primary text-sm font-normal font-['Inter'] leading-tight"
      >
        {label}
      </div>
      <div
        data-testid="site-of-care-type-count"
        className="text-right text-primary text-base font-normal font-['Inter'] leading-normal"
      >
        {siteOfCareType?.count}
      </div>
    </div>
  );
};

export default SiteBySiteOfCareTypeItem;
